import { render, staticRenderFns } from "./eduCard.vue?vue&type=template&id=d46ca62e&scoped=true&"
import script from "./eduCard.vue?vue&type=script&lang=js&"
export * from "./eduCard.vue?vue&type=script&lang=js&"
import style0 from "./eduCard.vue?vue&type=style&index=0&id=d46ca62e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46ca62e",
  null
  
)

export default component.exports